<template>
  <!--
    Extracted from SidebarMenu so a nav item can render its icon in more than one place: a
    plain link and a collapsible group header need the same glyph, and duplicating ~150 lines
    of inline SVG to get it is how the two drift apart.

    Matched on `title` exactly as before; this is a move, not a rewrite.
  -->
      <!-- Overview Icon -->
      <svg
        v-if="title === 'Overview'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="3" width="7" height="9" rx="1"/>
        <rect x="14" y="3" width="7" height="5" rx="1"/>
        <rect x="14" y="12" width="7" height="9" rx="1"/>
        <rect x="3" y="16" width="7" height="5" rx="1"/>
      </svg>
      <!-- Deals Icon -->
      <svg
        v-if="title === 'Deals'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M3 3v18h18"/>
        <path d="M18 17l-5-5-4 4-5-5"/>
      </svg>
      <!-- SPVs Icon -->
      <svg
        v-if="title === 'SPVs'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
        <line x1="8" y1="7" x2="16" y2="7"/>
        <line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
      <!-- Invest Icon -->
      <svg
        v-if="title === 'Invest'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </svg>
      <!-- Wallet Icon -->
      <svg
        v-if="title === 'Wallet'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/>
        <path d="M1 10h22"/>
        <circle cx="18" cy="15" r="1.5"/>
      </svg>
      <!-- Members Icon -->
      <svg
        v-if="title === 'Members'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
      <!-- Teams Icon -->
      <svg
        v-if="title === 'Teams'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <line x1="19" y1="8" x2="19" y2="14"/>
        <line x1="22" y1="11" x2="16" y2="11"/>
      </svg>
      <!-- Account Icon -->
      <svg
        v-if="title === 'Account'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
      <!-- API Icon -->
      <svg
        v-if="title === 'API'"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="focus ? '#4D84FF' : '#64748B'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="16 18 22 12 16 6"/>
        <polyline points="8 6 2 12 8 18"/>
        <line x1="12" y1="2" x2="12" y2="22"/>
      </svg>
</template>

<script>
export default {
  name: "SidebarIcon",

  props: {
    title: { type: String, default: () => "", required: true },
  },
};
</script>
